import React from 'react'
import { useTranslation } from "react-i18next";

const formatDateTime = (s) => {
    if (!s) return '';
    const d = new Date(s);
    if (isNaN(d.getTime())) return s;
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const Tr = ({ announcement, onEdit, onDelete }) => {
    const { t } = useTranslation();

    const from = formatDateTime(announcement.display_from) || t('operator_announcement.immediate');
    const until = formatDateTime(announcement.display_until) || t('operator_announcement.unlimited');

    const now = new Date();
    const fromOk = !announcement.display_from || new Date(announcement.display_from) <= now;
    const untilOk = !announcement.display_until || new Date(announcement.display_until) >= now;
    const isActive = announcement.is_enabled && fromOk && untilOk;

    let statusKey, statusClass;
    if (!announcement.is_enabled) {
        statusKey = 'operator_announcement.status_disabled';
        statusClass = 'op-ann-status-disabled';
    } else if (!fromOk) {
        statusKey = 'operator_announcement.status_scheduled';
        statusClass = 'op-ann-status-scheduled';
    } else if (!untilOk) {
        statusKey = 'operator_announcement.status_expired';
        statusClass = 'op-ann-status-expired';
    } else {
        statusKey = 'operator_announcement.status_active';
        statusClass = 'op-ann-status-active';
    }

    return (
        <tr>
            <td>{announcement.id}</td>
            <td className="op-ann-text-cell">{announcement.text}</td>
            <td className="op-ann-period-cell">
                <div>{from}</div>
                <div className="op-ann-period-sep">{'↓'}</div>
                <div>{until}</div>
            </td>
            <td>
                <span className={`op-ann-status-badge ${statusClass}`}>
                    {t(statusKey)}
                </span>
            </td>
            <td>{announcement.sort_order ?? 0}</td>
            <td>
                <button className="operator-announcement-list-content-table-button" onClick={() => onEdit(announcement)}>{t('operator_announcement.edit')}</button>
                <button className="operator-announcement-list-content-table-button-delete" onClick={() => onDelete(announcement)}>{t('operator_announcement.delete')}</button>
            </td>
        </tr>
    )
}

export default Tr
